$('form.ajax-form').each(function () {
    $(this).on('submit', function (event) {
        event.preventDefault();

        var $form = $(this);
        var $output = $form.find('.wpcf7-response-output');

        if ($form.data('locked')) {
            return false;
        }

        $output.addClass('d-none');
        $form.find('.wpcf7-not-valid-tip').remove();
        $form.find('.is-invalid').removeClass('is-invalid');
        $form.data('locked', true);
        $form.find('button').prop('disabled', 'disabled');

        $.post({
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            success: function (response) {
                $form[0].reset();

                $output.removeClass('d-none').text(response.success);

                $form.data('locked', false);
                $form.find('button').removeProp('disabled');

                $('html, body').animate({
                    scrollTop: $output.offset().top - 30,
                }, 300);
            },
            error: function (error) {
                var response = error.responseJSON;
                console.log('console:'+response);
                if (response) {
                    var anchor = null;

                    $.each(response.errors, function (field) {
                        // var selector = field.replace(/([A-z0-9\-_]+)\.?/g, "[$1]").replace(/\[/, '').replace(/\]/, '');

                        // var $control = $form.find('[name="' + selector + '"]');
                        // var $wrap = $control.parent('.wpcf7-form-control-wrap');
                        // var $fallback = $form.find('[data-errors="' + field + '"]');

                        // if ($control.length > 0) {
                        //     anchor = anchor || $wrap;
                        //     $control.addClass('is-invalid');
                        //     $wrap.append('<span role="alert" class="wpcf7-not-valid-tip">' + response.errors[field].pop() + '</span>');
                        // }

                        // if ($fallback.length > 0) {
                        //     $fallback.addClass('text-danger');
                        // }

                        let selector = $('.display-errors');
                        selector.addClass('text-danger').append('<div role="alert" class="wpcf7-not-valid-tip">' + response.errors[field].pop() + '</div>');

                        anchor = selector;
                    });

                    if (anchor) {
                        $('html, body').animate({
                            scrollTop: anchor.offset().top - 30,
                        }, 300);
                    }
                } else {
                    alert('Um erro desconhecido ocorreu! Tente novamente mais tarde.');
                }

                $form.data('locked', false);
                $form.find('button').removeProp('disabled');
            },
        });

        return false;
    });
});



// WEBPACK FOOTER //
// ./scripts/components/ajax-form.js